export enum RequestState {
    INITIAL = "INITIAL",
    LOADING = "LOADING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
}